import styled from 'styled-components';

import {ms} from '../../../styles';
import {Text} from '../../../uikit/Text';
import {View} from '../../../uikit/View';
import {isIamCoach} from '../../../utils/entity/isIamCoach';

export const Container = styled(View)`
  flex-direction: column;
  row-gap: ${ms(20)};
`;

export const Section = styled(View)`
  flex-direction: column;
  row-gap: ${ms(12)};
`;

export const Row = styled(View)`
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled(Text).attrs({
  weight: 'bold',
})`
  font-size: ${ms(16)};
`;

export const Label = styled(Text)`
  font-size: ${ms(16)};
`;

export const Value = styled(Text).attrs({
  color: isIamCoach() ? 'text4' : 'text5',
  weight: 'semibold',
})`
  font-size: ${ms(16)};
`;
